import Immutable from 'seamless-immutable';
import PropTypes from 'prop-types';
import { retrieveErrors } from '@widergy/web-utils/lib/message';
import { AlertHandler } from '@widergy/energy-ui';

import * as PointService from '../services/PointService';
import { message } from '../utils/stringUtils';

import { stringArrayToObject } from './utils';

/* ------------- Point actions ------------- */
export const actions = stringArrayToObject(
  [
    'LOADING',
    'GET_POINTS_DETAIL_SUCCESS',
    'GET_POINTS_DETAIL_FAILURE',
    'APPEND_POINTS_SUCCESS',
    'APPEND_POINTS_FAILURE'
  ],
  '@@POINT'
);

export const actionCreators = {
  loading(loading = true) {
    return {
      type: actions.LOADING,
      payload: loading
    };
  },
  getPointsDetail(pageNumber, pageSize) {
    return async dispatch => {
      dispatch(actionCreators.loading(true));
      const pointsResult = await PointService.getPointsDetail(pageNumber, pageSize);
      if (pointsResult.ok) {
        dispatch(actionCreators.getPointsDetailSuccess(pointsResult.data));
      } else {
        AlertHandler.error(
          retrieveErrors(pointsResult.data, message('DefaultMessages:getPointsDetailFailure'))
        );
      }
    };
  },
  getPointsDetailSuccess(pointsInformation) {
    return {
      type: actions.GET_POINTS_DETAIL_SUCCESS,
      payload: {
        pointsInformation
      }
    };
  },
  appendPointsTransactions(accountId, pageNumber, pageSize) {
    return async dispatch => {
      dispatch({ type: actions.APPEND_POINTS });
      const pointsResult = await PointService.getPointsDetail(accountId, pageNumber, pageSize);
      if (pointsResult.ok) {
        dispatch(actionCreators.appendPointsSuccess(pointsResult.data));
      } else {
        dispatch(actionCreators.appendPointsFailure(pointsResult.data));
        AlertHandler.error(
          retrieveErrors(pointsResult.data, message('DefaultMessages:appendPointsTransactionsFailure'))
        );
      }
    };
  },
  appendPointsSuccess(pointsInformation) {
    return {
      type: actions.APPEND_POINTS_SUCCESS,
      payload: {
        pointsInformation
      }
    };
  },
  appendPointsFailure(error) {
    return {
      type: actions.APPEND_POINTS_FAILURE,
      payload: {
        error
      }
    };
  }
};

const defaultState = {
  loading: false,
  pointsDetail: null,
  pointsDetailError: null
};

/* ------------- Point reducer ------------- */
/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.LOADING: {
      return Immutable.merge(state, { loading: action.payload });
    }
    case actions.GET_POINTS_DETAIL_SUCCESS: {
      return Immutable.merge(state, {
        pointsDetail: {
          period_points: action.payload.pointsInformation.current_period_points || 0,
          total_points: action.payload.pointsInformation.current_total_points || 0,
          point_transactions: action.payload.pointsInformation.point_transactions || []
        },
        loading: false,
        pointsDetailError: null
      });
    }
    case actions.APPEND_POINTS: {
      return Immutable.merge(state, {
        appendPointsLoading: true
      });
    }
    case actions.APPEND_POINTS_SUCCESS: {
      return Immutable.merge(state, {
        pointsDetail: {
          period_points: state.pointsDetail.period_points,
          total_points: state.pointsDetail.total_points,
          point_transactions: [
            ...state.pointsDetail.point_transactions,
            ...action.payload.pointsInformation.point_transactions
          ]
        },
        appendPointsLoading: false
      });
    }
    case actions.APPEND_POINTS_FAILURE: {
      return Immutable.merge(state, {
        error: action.payload.error,
        appendPointsLoading: false
      });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

/* ------------- Point propTypes ------------- */
export const pointsDetailsPropTypes = PropTypes.shape({
  period_points: PropTypes.number.isRequired,
  total_points: PropTypes.number.isRequired,
  point_transactions: PropTypes.arrayOf(
    PropTypes.shape({
      period: PropTypes.string.isRequired,
      points: PropTypes.number.isRequired,
      total_points_after_transaction: PropTypes.number.isRequired,
      category: PropTypes.string.isRequired
    })
  ),
  pointsHistory: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
});
